<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center flex-wrap" style="gap: 12px">
        <h2>Conversaciones de Festy Bot</h2>
        <v-select v-model="channel" :items="channels" dense outlined hide-details style="max-width: 200px" @change="load()" />
        <v-spacer />
        <span class="body-2 grey--text">Se actualiza cada 20 segundos</span>
        <v-btn text :loading="loading" @click="load()"><v-icon left>mdi-refresh</v-icon> Actualizar</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="5">
        <v-card>
          <v-text-field v-model="search" label="Buscar por nombre, celular o mensaje" dense flat solo hide-details clearable prepend-inner-icon="mdi-magnify" class="px-2 pt-2" />
          <v-data-table
            :headers="headers"
            :items="sessions"
            :search="search"
            :loading="loading"
            :items-per-page="15"
            sort-by="updatedAt"
            sort-desc
            dense
            no-data-text="Aún no hay conversaciones"
            :item-class="item => item.id === selectedId ? 'blue lighten-5' : ''"
            style="cursor: pointer"
            @click:row="open"
          >
            <template #item.channelLabel="{ item }"><v-chip x-small :color="channelColor(item.channel)" dark>{{ item.channelLabel }}</v-chip></template>
            <template #item.name="{ item }">
              <div>{{ item.name || 'Sin nombre' }}</div>
              <div class="caption grey--text">{{ item.phone || item.externalId }}</div>
            </template>
            <template #item.lastText="{ item }"><span class="caption">{{ item.lastText }}</span></template>
            <template #item.updatedAt="{ item }"><span class="caption">{{ ago(item.updatedAt) }}</span></template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="7">
        <v-card v-if="!current" class="pa-8 text-center grey--text">Elige una conversación para leerla.</v-card>
        <v-card v-else>
          <v-toolbar flat color="#f6f6f6">
            <v-chip small :color="channelColor(current.channel)" dark class="mr-2">{{ current.channelLabel }}</v-chip>
            <v-toolbar-title class="subtitle-1">{{ current.name || 'Sin nombre' }} <span class="grey--text">· {{ current.phone || current.externalId }}</span></v-toolbar-title>
            <v-spacer />
            <v-btn v-if="current.phone" icon :href="'https://wa.me/57' + current.phone" target="_blank" rel="noopener" title="Escribirle por WhatsApp"><v-icon color="green">mdi-whatsapp</v-icon></v-btn>
            <v-btn icon :loading="loadingOne" title="Recargar" @click="open(current)"><v-icon>mdi-refresh</v-icon></v-btn>
            <v-btn icon title="Borrar historial del bot (el cliente empieza de cero)" @click="confirmReset = true"><v-icon>mdi-delete-sweep-outline</v-icon></v-btn>
          </v-toolbar>

          <v-card-text v-if="current.address" class="pb-0 body-2"><b>Última dirección:</b> {{ current.address }}</v-card-text>

          <v-card-text v-if="current.orders && current.orders.length" class="pb-0">
            <div class="subtitle-2 mb-1">Pedidos creados por el bot</div>
            <v-chip v-for="o in current.orders" :key="o.id" small class="mr-1 mb-1" :to="'/orders'">#{{ o.id }} · {{ o.store }} · {{ money(o.total) }} · {{ o.status }}</v-chip>
          </v-card-text>

          <v-card-text>
            <div class="chat">
              <div v-for="(m, i) in current.transcript" :key="i" :class="['line', m.who]">
                <div class="bubble">{{ m.text }}</div>
              </div>
              <div v-if="!current.transcript.length" class="grey--text text-center py-6">Sin mensajes.</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="confirmReset" max-width="420">
      <v-card>
        <v-card-title>Borrar historial</v-card-title>
        <v-card-text>El bot olvidará esta conversación y empezará de cero con el cliente. Los pedidos ya creados no se tocan.</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="confirmReset = false">Cancelar</v-btn>
          <v-btn color="error" @click="reset">Borrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Parse from 'parse'

export default {
  name: 'BotConversations',
  data: () => ({
    sessions: [],
    current: null,
    selectedId: null,
    loading: false,
    loadingOne: false,
    search: '',
    channel: '',
    confirmReset: false,
    timer: null,
    channels: [
      { text: 'Todos los canales', value: '' },
      { text: 'Tienda web', value: 'web' },
      { text: 'WhatsApp', value: 'whatsapp' },
      { text: 'Messenger', value: 'messenger' },
      { text: 'Instagram', value: 'instagram' }
    ],
    headers: [
      { text: 'Canal', value: 'channelLabel', width: 110 },
      { text: 'Cliente', value: 'name' },
      { text: 'Último mensaje', value: 'lastText', sortable: false },
      { text: 'Turnos', value: 'turns', align: 'end', width: 80 },
      { text: 'Hace', value: 'updatedAt', width: 100 }
    ]
  }),
  mounted () {
    this.load()
    this.timer = setInterval(() => { if (!document.hidden) this.load(true) }, 20000)
  },
  beforeDestroy () { clearInterval(this.timer) },
  methods: {
    money: n => '$' + String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
    ago (d) {
      const m = Math.round((Date.now() - new Date(d).getTime()) / 60000)
      return m < 1 ? 'ahora' : m < 60 ? `${m} min` : m < 1440 ? `${Math.round(m / 60)} h` : `${Math.round(m / 1440)} d`
    },
    channelColor: c => ({ web: 'blue-grey', whatsapp: 'green', messenger: 'blue', instagram: 'purple' }[c] || 'grey'),
    fail (error, title) {
      this.$snotify.error(`${error && error.message ? error.message : error}`, title, { timeout: 5000, preventDuplicates: true })
    },
    async load (silent) {
      if (!silent) this.loading = true
      try {
        const params = { limit: 300 }
        if (this.channel) params.channel = this.channel
        this.sessions = await Parse.Cloud.run('getBotSessionsBO', params)
        if (silent && this.current) {
          const row = this.sessions.find(s => s.id === this.current.id)
          if (row && row.updatedAt !== this.current.updatedAt) this.open(row, true)
        }
      } catch (error) {
        this.fail(error, 'Festy Bot')
      } finally {
        this.loading = false
      }
    },
    async open (item, silent) {
      this.selectedId = item.id
      if (!silent) this.loadingOne = true
      try {
        this.current = await Parse.Cloud.run('getBotSessionBO', { id: item.id })
      } catch (error) {
        this.fail(error, 'Festy Bot')
      } finally {
        this.loadingOne = false
      }
    },
    async reset () {
      this.confirmReset = false
      try {
        await Parse.Cloud.run('resetBotSessionBO', { id: this.current.id })
        this.open(this.current)
        this.load(true)
      } catch (error) {
        this.fail(error, 'Festy Bot')
      }
    }
  }
}
</script>

<style scoped>
.chat { display: flex; flex-direction: column; gap: 8px; max-height: 60vh; overflow-y: auto; padding: 4px; background: #f6f5ef; border-radius: 8px; }
.line { display: flex; max-width: 85%; }
.line.cliente { align-self: flex-end; }
.line.bot { align-self: flex-start; }
.line.sistema { align-self: center; max-width: 100%; }
.bubble { padding: 8px 12px; border-radius: 14px; font-size: 14px; line-height: 1.45; white-space: pre-wrap; word-break: break-word; }
.line.cliente .bubble { background: #f3d923; border-bottom-right-radius: 4px; }
.line.bot .bubble { background: #fff; border: 1px solid #e3e0d2; border-bottom-left-radius: 4px; }
.line.sistema .bubble { background: transparent; color: #625e4e; font-size: 12px; font-style: italic; padding: 2px 8px; }
</style>
